import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { onTextEntered } from '../events';
import { withAnalytics } from '../with-analytics';
import debounce from 'lodash/debounce';
export var TextEnteredHandler = /*#__PURE__*/function (_React$Component) {
  function TextEnteredHandler() {
    var _this;
    _classCallCheck(this, TextEnteredHandler);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TextEnteredHandler, [].concat(args));
    _defineProperty(_this, "textEntered", debounce(function () {
      var _this$props = _this.props,
        textEntered = _this$props.textEntered,
        activeProduct = _this$props.activeProduct;
      textEntered(activeProduct);
    }, _this.props.debounceTime || 0));
    return _this;
  }
  _inherits(TextEnteredHandler, _React$Component);
  return _createClass(TextEnteredHandler, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;
      var query = this.props.query;
      if (prevProps.query !== query) {
        /**
         * Earlier this component was child of [confluence|jira]-search-dialog which ensured that this got fired after the debounced search.
         * Now it will get moved to the wrapper component which will bring this at the same level as [confluence|jira]-search-dialog.
         * This leads to the event handler getting fired in the same tick before the debounced search.
         * Hence, forceful execution in the next tick.
         */
        setTimeout(function () {
          return _this2.textEntered();
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.textEntered.cancel();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
}(React.Component);
export default withAnalytics({
  textEntered: onTextEntered
})(TextEnteredHandler);